function ignoreCaseEqualityValidator({ configs, fieldValues, fields, input, msgs }) {
  const field = fields[configs.clientId];
  const value = fieldValues[configs.clientId];

  if (field && value && input && value.toLowerCase() !== input.toLowerCase()) {
    return (msgs && msgs.msg) || `Value must match ${field.label}`;
  }

  return null;
}

export default ignoreCaseEqualityValidator;
